export class Generalsearchrequest {
    busquedaGeneral:string;
    // daet ini
    fecIni:string;
    fecFin:string;
    // daet fin
    categoria:string;
    page:string;
    size:string;
    constructor(){
        this.busquedaGeneral="";
        this.page="";
        this.size="";
        // daet ini
        this.fecIni="";
        this.fecFin="";
        // daet fin
        this.categoria="";
    }
}
